import { render, staticRenderFns } from "./FormReserved.vue?vue&type=template&id=18d19d49&"
import script from "./FormReserved.vue?vue&type=script&lang=ts&"
export * from "./FormReserved.vue?vue&type=script&lang=ts&"
import style0 from "./FormReserved.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports